
















import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { AppWindowSettings, AppWindowMode } from '@/modules/configuration/store/types';
import AdminMode from '@/components/AdminMode.vue';
import Calendar from '@/modules/calendar/components/Calendar.vue';
import ScheduleBoard from '@/modules/workshops-schedule/components/ScheduleBoard.vue';
import Schedule from '@/modules/workshops-schedule/components/Schedule.vue';
import LandingPageForm from '@/modules/workshops-schedule/components/LandingPageForm.vue';
import EventRegistrationCancellation from '@/modules/workshops-schedule/components/EventRegistrationCancellation.vue';
import EventTicketChange from '@/modules/workshops-schedule/components/EventTicketChange.vue';
import MarathonRegistration from '@/modules/workshops-schedule/components/MarathonRegistration.vue';
import ArtistRegistration from '@/modules/workshops-schedule/components/ArtistRegistration.vue';
import GenericForm from '@/modules/form/components/GenericForm.vue';

@Component({
    name: 'AppWindow',
    components: {
        Calendar,
        GenericForm,
        AdminMode,
        ScheduleBoard,
        Schedule,
        LandingPageForm,
        EventRegistrationCancellation,
        EventTicketChange,
        MarathonRegistration,
        ArtistRegistration,
    },
})
export default class AppWindow extends Vue {
    @Getter('appWindowSettings', { namespace: 'configuration' }) private appWindowSettings!: AppWindowSettings;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('changeAppWindowMode', { namespace: 'configuration' }) private changeAppWindowMode: any;
    @Action('changeEventId', { namespace: 'form' }) private changeEventId: any;
    @Action('changeFormFlowId', { namespace: 'form' }) private changeFormFlowId: any;

    private get appWindowMode() {
        this.setAppWindowMode();
        this.setEventId();
        this.setFormFlowId();
        return this.appWindowSettings.mode;
    }

    private setAppWindowMode() {
        const appWindowMode = document.getElementById('appWindowMode')?.innerText.trim();
        if (appWindowMode !== undefined) {
            if (AppWindowMode.values.includes(appWindowMode)) {
                this.changeAppWindowMode(appWindowMode);
            }
        }

        return undefined;
    }

    private setEventId() {
        const eventIdString = document.getElementById('eventId')?.innerText.trim();
        if (eventIdString !== undefined) {
            const eventId = +eventIdString as number;
            this.changeEventId(eventId);
        }

        return undefined;
    }

    private setFormFlowId() {
        const formFlowIdString = document.getElementById('formFlowId')?.innerText.trim();
        if (formFlowIdString !== undefined) {
            const formFlowId = +formFlowIdString as number;
            this.changeFormFlowId(formFlowId);
        }

        return undefined;
    }
}
